import FeedBackGroupView from './FeedBackGroupView'
export default FeedBackGroupView
